import {ActionsColumn, Column, CRUD, CRUDActions, IdColumn, RowRenderer} from 'react-admin-base-bootstrap';
import {Breadcrumb} from 'react-admin-base-nazox';
import TeamMemberEntity from "./TeamMemberEntity";
import LanguageSpan from "../../Components/LanguageSpan";

const defaultParams = { order: 'order' };

export default function TeamMembers() {
    return <Breadcrumb
        title="Team Members"
        data={
            [
                {
                    href: '/team-member',
                    name: 'Team Members'
                }
            ]
        }
    >
        <CRUD url="/team-member" Component={TeamMemberEntity} defaultParams={defaultParams}>
            <thead>
                <tr>
                    <IdColumn />
                    <Column className="min" sort="enabled">Enabled</Column>
                    <Column className="min">Language</Column>
                    <Column className="min" sort="order">Order</Column>
                    <Column sort="name">Name</Column>
                    <Column sort="title">Title</Column>
                    <ActionsColumn />
                </tr>
            </thead>
            <RowRenderer
                render={row => <tr key={row.id}>
                    <td className="min text-center">{row.id}</td>
                    <td className="min">{row.enabled ? 'Yes' : 'No'}</td>
                    <td className="min"><LanguageSpan value={row.language} /></td>
                    <td className="min">{row.order}</td>
                    <td>{row.name}</td>
                    <td>{row.title}</td>
                    <CRUDActions
                        id={row.id}
                        edit
                        del={"/team-member/" + row.id}
                    />
                </tr>}
            />
        </CRUD>
    </Breadcrumb>;
}
